<template>
  <div v-click-outside="removeSearch">
    <div :class="{ 'luxury-input p-3': isluxury }">
      <div style="width: 100%">
        <div class="position-relative">
          <label for="search" class="w-100 mb-0" title="search box">
            <input type="text" id="search" class="vehicle_input rounded-inputs website-input-box"
              @input="searchVehicles($event)" @keyup.esc="removeSearch()" @keyup.enter="navigateToFirstVehicle()"
              v-model="searchkey" @keydown="selectSearch" :placeholder="setPlaceholderText" maxlength="50" />

            <em class="primaryicon-search search-icon color-secondary"></em>
          </label>
          <div class="autocomplete_vehicles" :class="[vehiclesdata.length == 1 ? 'set-height' : '']" :style="boxstyle">
              <ul v-if="vehiclesdata.length" class="vehicles-dropdown">
                <li ref="vehicleItems" v-for="(value, index) in vehiclesdata" :key="index"
                  @click="searchItemClick(index)" :class="{ focus: index === focus }">
                  <a :href="`${baseUrl}${value.link}`" class="d-inline-block p-3">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-text">{{ value.vehcileName }}</div>
                    </div>
                  </a>
                </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" src="./InventoryVehicleSearch.js"></script>


<style scoped>
.luxury-input {
  background: #eee;
}

.vehicle_input {
  border-radius: 5px;
  border: 1px solid #ddd;
  width: 100%;
  height: 40px;
  padding: 10px 0px 10px 40px;
}

.autocomplete_vehicles {
  background-color: #fff;
  z-index: 20;
  width: 100%;
}

.vehicles-dropdown {
  width: 100%;
  list-style: none;
  margin: 0px;
  padding: 0px;
  height: 250px;
  overflow-y: auto;
}

.set-height .vehicles-dropdown {
  height: 52px;
}

.vehicles-dropdown li {
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.vehicles-dropdown li a {
  padding: 10px;
  width: 100%;
  color: #555;
}

.autocomplete_vehicles::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.autocomplete_vehicles::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.vehicles-dropdown li a:hover {
  text-decoration: none;
  background-color: #ddd;
}

.dropdown-image {
  width: 55px;
  height: 40px;
}

.dropdown-text {
  font-size: 12px;
  margin-left: 10px;
}

.search-icon {
  position: absolute;
  top: 8px;
  left: 15px;
  padding: 3px;
  border-radius: 3px;
  color: #fff;
}

.vehicles-dropdown li.focus {
  text-decoration: none;
  background-color: #ddd;
}
</style>
